import React, { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

class DocsErrorBoundary extends React.Component {
  state = { err: null };
  static getDerivedStateFromError(err) { return { err }; }
  render() {
    if (this.state.err) {
      return (
        <div className="docs-loading">
          Something went wrong loading this page.{" "}
          <a href={window.location.pathname}>Reload</a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function DocsShell() {
  const location = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  return (
    <div className="tm-docs">
      <main className="docs-main">
        <DocsErrorBoundary key={location.pathname}>
          <Suspense fallback={<div className="docs-loading">Loading…</div>}>
            <Outlet />
          </Suspense>
        </DocsErrorBoundary>
      </main>
    </div>
  );
}
